import React from "react";
import ReactDOM from "react-dom";
import { PaymentForm, CreditCard as SquareCreditCard } from "react-square-web-payments-sdk";
import { toast } from "react-toastify";
import axios from "axios";

const SquarePaymentPortal = ({ open, onClose, orderId, amount, settings, onSuccess }) => {
  if (!open) return null;

  const handlePayment = async (tokenResult) => {
    try {
      const { token } = tokenResult;
      const { data } = await axios.post(`${window.BASE_API_URL}place-order`, {
        orderId,
        amount,
        token,
        live: settings?.squareup_live || 0,
        type: 'squareup'
      });

      // console.log("Square API Response:", data);

      if (data?.payment?.status === "COMPLETED" || data?.success) {
        toast.success("✅ Payment Successful!");
        onSuccess({ success: true, orderId: data?.id });
        onClose();
      } else {
        toast.error("❌ Square payment failed");
      }
    } catch (err) {
      console.error("❌ Square Payment Error:", err);
      toast.error("Square payment failed");
    }
  };

  const env = settings?.squareup_live === 1 ? "PRODUCTION" : "SANDBOX";

  return ReactDOM.createPortal(
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[999999]">
      <div className="bg-white rounded-2xl p-6 w-[400px] relative shadow-lg">
        <h3 className="text-xl font-semibold mb-4 text-gray-800">Square Payment</h3>

        <PaymentForm
          applicationId={settings?.squareup_app_id}
          locationId={settings?.squareup_location}
          environment={env}
          cardTokenizeResponseReceived={handlePayment}
        >
          <SquareCreditCard
            buttonProps={{
              children: "Pay with Square",
              css: {
                backgroundColor: "#16a34a",
                color: "#fff",
                borderRadius: "8px",
                fontSize: "16px",
                fontWeight: "bold",
                padding: "10px 16px",
                width: "100%",
              },
            }}
          />
        </PaymentForm>

        <button
          onClick={onClose}
          className="absolute top-3 right-4 text-gray-500 hover:text-gray-800"
        >
          ✕
        </button>
      </div>
    </div>,
    document.body
  );
};

export default SquarePaymentPortal;
